export const AppRoutes = {
  ROOT: '',
  HOME: 'home',

  CREATE_NOTICE: 'avis/creer',
  MODIFY_NOTICE: 'avis/modifier',
  VALIDATE_NOTICE: 'avis/validation',
  MY_NOTICES: 'avis/mes-avis',

  HISTORY: 'preparation/historique',
  EDMS_DOCUMENTS: 'preparation/documents-edms',
  SPARE_PARTS: 'preparation/pieces-detachees',

  WORK_ORDER_PORTFOLIO: 'ot/portefeuille',
  OPERATIONS_PLANNING: 'ot/planning',

  INTERVENTION_REPORT: 'cr/intervention',
  VALIDATE_INTERVENTION_REPORT: 'cr/validation',

  USERS_AND_ROLES: 'admin/utilisateurs',

  SETTINGS: 'admin/settings',

  NOT_FOUND: '**',
} as const;

export type AppRoute = (typeof AppRoutes)[keyof typeof AppRoutes];

/** Converts a route definition into an absolute URL for RouterLink/navigation. */
export function appUrl(route: AppRoute): `/${string}` {
  return `/${route}`;
}
